import { Locale } from 'chaika-enums';
export const dictation = {
    voiceInput: {
        [Locale.Ru]: 'Голосовой ввод',
        [Locale.Am]: 'Ձայնային մուտքագրում',
        [Locale.En]: 'Voice input',
        [Locale.Pt]: 'Entrada de voz',
        [Locale.Ge]: 'Voice input',
    },
    dictationConnecting: {
        [Locale.Ru]: 'Подключение…',
        [Locale.Am]: 'Միացում…',
        [Locale.En]: 'Connecting…',
        [Locale.Pt]: 'Conectando…',
        [Locale.Ge]: 'Connecting…',
    },
    stopDictation: {
        [Locale.Ru]: 'Остановить диктовку',
        [Locale.Am]: 'Դադարեցնել թելադրությունը',
        [Locale.En]: 'Stop dictation',
        [Locale.Pt]: 'Parar ditado',
        [Locale.Ge]: 'Stop dictation',
    },
    dictationMicrophoneUnavailable: {
        [Locale.Ru]: 'Нет доступа к микрофону. Проверьте разрешения браузера',
        [Locale.Am]: 'Խոսափողը հասանելի չէ։ Ստուգեք բրաուզերի թույլտվությունները',
        [Locale.En]: 'Microphone unavailable. Check browser permissions',
        [Locale.Pt]: 'Microfone indisponível. Verifique as permissões do navegador',
        [Locale.Ge]: 'Microphone unavailable. Check browser permissions',
    },
    dictationStartFailed: {
        [Locale.Ru]: 'Не удалось запустить диктовку. Попробуйте ещё раз',
        [Locale.Am]: 'Չհաջողվեց սկսել թելադրությունը։ Փորձեք նորից',
        [Locale.En]: 'Failed to start dictation. Try again',
        [Locale.Pt]: 'Falha ao iniciar o ditado. Tente novamente',
        [Locale.Ge]: 'Failed to start dictation. Try again',
    },
    dictationInterrupted: {
        [Locale.Ru]: 'Диктовка прервана. Распознанный текст сохранён',
        [Locale.Am]: 'Թելադրությունն ընդհատվեց։ Ճանաչված տեքստը պահպանվել է',
        [Locale.En]: 'Dictation interrupted. Recognized text was kept',
        [Locale.Pt]: 'Ditado interrompido. O texto reconhecido foi mantido',
        [Locale.Ge]: 'Dictation interrupted. Recognized text was kept',
    },
    dictationStoppedOnSilence: {
        [Locale.Ru]: 'Диктовка остановлена — речи не слышно',
        [Locale.Am]: 'Թելադրությունը դադարեցվեց — խոսք չի լսվում',
        [Locale.En]: 'Dictation stopped — no speech detected',
        [Locale.Pt]: 'Ditado interrompido — nenhuma fala detectada',
        [Locale.Ge]: 'Dictation stopped — no speech detected',
    },
    dictationUtteranceFailed: {
        [Locale.Ru]: 'Не удалось распознать фразу',
        [Locale.Am]: 'Չհաջողվեց ճանաչել արտահայտությունը',
        [Locale.En]: 'Failed to recognize the phrase',
        [Locale.Pt]: 'Falha ao reconhecer a frase',
        [Locale.Ge]: 'Failed to recognize the phrase',
    },
};
